'use client';

import AppImage from '@/components/ui/AppImage';

import useScrollReveal from '@/hooks/useScrollReveal';

export default function ServicesHero() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={heroRef} className="relative py-20 sm:py-24 md:py-32 lg:py-40 overflow-hidden bg-gradient-to-br from-brand-plum via-brand-plum to-brand-teal">
      {/* Hero Image */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1f977937c-1772129382091.png"
          alt="Creative collaboration in gritty urban environment with street art and industrial aesthetic showing raw authentic energy"
          width={1920}
          height={1080}
          className="w-full h-full object-cover" />
        
        {/* Dark overlay for edge */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 text-center z-10">
        <div className={`transition-all duration-1000 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-block px-3 py-1.5 sm:px-5 sm:py-2 bg-brand-teal text-white font-body text-[10px] sm:text-xs font-bold mb-3 sm:mb-4 uppercase tracking-wider transition-all duration-300 hover:bg-brand-green">
            NO FLUFF • NO COMPLEXITY • JUST WHAT WORKS
          </div>
          <h1 className="font-headline text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-3 sm:mb-4 text-white font-bold leading-tight">
            Services
          </h1>
          <p className="font-body text-sm sm:text-base md:text-lg text-white leading-relaxed max-w-3xl mx-auto px-4">
            Here's what we do: brand strategy, websites, systems. The infrastructure that lets you focus on your mission instead of fighting with broken tools. No unnecessary complexity. Just the stuff you actually need to compete and grow.
          </p>
        </div>
      </div>
    </section>);

}